import { render, staticRenderFns } from "./orderPaid.vue?vue&type=template&id=dd38b63a&scoped=true&"
import script from "./orderPaid.vue?vue&type=script&lang=js&"
export * from "./orderPaid.vue?vue&type=script&lang=js&"
import style0 from "./orderPaid.vue?vue&type=style&index=0&id=dd38b63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd38b63a",
  null
  
)

export default component.exports